const taskPodHeader = [
  // customer_name: true,
  // customer_display_name: true,
  // contact_name: true,
  // project_name: true,
  // project_code: true,
  // link_to_project_pod: true,
  // legal_entity:true ,
  // gfpo_company: true,
  // software: true,
  // tax_year_end:true ,
  // annual_accounts_month: true,
  // project_partner:true ,
  // manager_reviewer: true,
  // project_status: true,
  // start_date: true,
  // end_date: true,
  // created_by: true,
  // updated_by: true,
  // created_at: true,
  // updated_at: true,
  {
    completionAction: "Done",
    completion_action_status: "1",
  },
  {
    customer_name: "Company Name",
    customer_name_status: "1",
  },
  {
    contact_name: "Contact Name",
    contact_name_status: "1",
  },

  {
    customer_display_name: "Contact Name",
    customer_display_name_status: "1",
  },
  {
    project_name: "Project Name",
    project_name_status: "1",
  },
  {
    project_code: "Project Code",
    project_code_status: "1",
  },
  {
    link_to_project_pod: "Link to Project Pod",
    link_to_project_pod_status: "1",
  },
  {
    legal_entity: "Legal Entity",
    legal_entity_status: "1",
  },
  {
    gfpo_company: "GFPO Company",
    gfpo_company_status: "1",
  },
  {
    software: "Software",
    software_status: "1",
  },
  {
    tax_year_end: "Tax Year End",
    tax_year_end_status: "1",
  },
  {
    annual_accounts_month: "Annual Accounts Month",
    annual_accounts_month_status: "1",
  },
  {
    project_partner: "Project Partner",
    project_partner_status: "1",
  },
  {
    manager_reviewer: "Manager Reviewer",
    manager_reviewer_status: "1",
  },
  {
    project_status: "Project Status",
    project_status_status: "1",
  },
  {
    subject: "Task Name",
    subject_status: "1",
  },
  {
    task_pod: "Taskpod",
    task_pod_status: 1,
  },
  {
    due_date: "Due Date",
    due_date_status: 1,
  },
  {
    start_date: "Start Date",
    start_date_status: 1,
  },
  {
    end_date: "End Date",
    end_date_status: 1,
  },
  {
    assigned_to: "Assignee",
    assignee_status: "1",
  },

  {
    status: "Status",
    status_status: "1",
  },
  {
    priority: "Priority",
    priority_status: "1",
  },

  {
    activity: "Activity",
    activity_status: 1,
  },

  {
    job_status_funnel: "Job Status Funnel",
    job_status_funnel_status: 1,
  },
  {
    service_name: "Service Name",
    service_name_status: 1,
  },
  {
    return_type: "Return Type",
    return_type_status: 1,
  },
  {
    complexity: "Complexity",
    complexity_status: 1,
  },
  {
    status_date: "Status Date",
    status_date_status: "1",
  },
  {
    project_name: "Project Name",
    project_name_status: 1,
  },
  {
    manager_reviewer: "Manager Reviewer",
    manager_reviewer_status: 1,
  },
  {
    tax_year_end: "Tax Year End",
    tax_year_end_status: 1,
  },
  {
    project_review_manager: "Project Review Manager",
    project_review_manager_status: 1,
  },
  {
    billing_status: "Billing Status",
    billing_status_status: 1,
  },
  {
    billing_date: "Billing Date",
    billing_date_status: 1,
  },
  {
    invoice_number: "Invoice Number",
    invoice_number_status: 1,
  },
  {
    time_tracked: "Time Tracked",
    time_tracked_status: 1,
  },
  {
    target_delivery_date: "Target Delivery Date",
    target_delivery_date_status: 1,
  },
  {
    payment_status: "Payment Status",
    payment_status_status: 1,
  },
  // {
  //   description: "Description",
  //   description_status: "1",
  // }

  {
    description: "Description",
    description_status: 1,
  },

  {
    created_by: "Created By",
    created_by_status: 1,
  },
  {
    created_at: "Created At",
    created_at_status: 1,
  },
  {
    updated_by: "Updated By",
    updated_by_status: 1,
  },
  {
    updated_at: "Updated At",
    updated_at_status: 1,
  },
];
export default taskPodHeader;
